import logoUrl from '../../../assets/images/doctor-legal/logo-11-trim.png'

export default function Footer() {
  return (
    <footer className="bg-surface-dark pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-1">
            <img
              src={logoUrl}
              alt="Doctor Legal"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm leading-relaxed text-white/50">
              Proteção jurídica levada a sério. A plataforma que traduz o
              direito para quem salva vidas.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest mb-6 text-white/30">
              Plataforma
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#a-plataforma" className="text-sm text-white/60 transition-colors hover:text-white">
                  Cursos
                </a>
              </li>
              <li>
                <a href="#a-plataforma" className="text-sm text-white/60 transition-colors hover:text-white">
                  Acervo Jurídico
                </a>
              </li>
              <li>
                <a href="#a-plataforma" className="text-sm text-white/60 transition-colors hover:text-white">
                  Consultoria
                </a>
              </li>
              <li>
                <a href="#planos" className="text-sm text-white/60 transition-colors hover:text-white">
                  Planos
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest mb-6 text-white/30">
              Suporte
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#faq" className="text-sm text-white/60 transition-colors hover:text-white">
                  Dúvidas Frequentes
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5511999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/60 transition-colors hover:text-white"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato@doctorlegal.com.br"
                  className="text-sm text-white/60 transition-colors hover:text-white"
                >
                  contato@doctorlegal.com.br
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest mb-6 text-white/30">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-white/60 transition-colors hover:text-white">
                  Termos de Uso
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/60 transition-colors hover:text-white">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/60 transition-colors hover:text-white">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 gap-4">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} Doctor Legal. Todos os direitos reservados.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="opacity-40 transition-opacity hover:opacity-100"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="opacity-40 transition-opacity hover:opacity-100"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
